import React, { useEffect, useState } from "react";
import { Toast } from "./../UI/toast/Toast";
import { SUCCESS_RESPONSE } from "../../helpers/codeResponses/codes";
import PageHeader from "../common/PageHeader";
import handleErrorMessage from "../../helpers/errors/handleErrorMessage";
import withRedirect from "../../helpers/hoc/withRedirect";
import { useParams, useLocation, useHistory } from "react-router";
import { fetchProviders } from "../../helpers/api/provider";
import useSWRFetchPagination from "../../helpers/hooks/useSWRFetchPagination";
import { PreloadState } from "../UI/preloading/PreloadState";
import SupportLink from "../root/support/components/SupportLink";
import { findOne, update } from "../../helpers/api/finance";
import { useSelector } from "react-redux";
import CreateCommonCostsEditForm from "./CreateCommonCostsEditForm";
import useModuleBase from "../../helpers/hooks/useModuleBase";


const CreateCommonCostsEdit = ({ setRedirectUrl, setRedirect }) => {
  const moduleBase = useModuleBase();

  const { id, commonId } = useParams();

  const [params] = useState({
    condominiumId: id,
  });

  const { selectedCondominium } = useSelector((state) => state.condominium);
  const { state } = useLocation();
  const history = useHistory();

  const {
    mutate,
    data,
    isLoading,
    meta,
    handler: { nextPage, previousPage, perPage, goToPage },
  } = useSWRFetchPagination(fetchProviders, params);

  const handleEdit = async (values) => {
    try {
      // Clean up payload: remove objects and legacy sub_expenses
      const payload = { ...values };
      delete payload.provider;
      delete payload.condominium;
      delete payload.type;
      delete payload.sub_expenses;

      const { code } = await update(commonId, {
        ...payload,
        condominium_id: Number(id),
        type_id: state?.type_id,
      });
      if (code === SUCCESS_RESPONSE.OK) {
        history.push({
          pathname: `/dashboard/${moduleBase}/${id}/common-costs`,
          state: {
            type_id: state?.type_id,
            type_name: state?.type_name,
          },
        });

        /*       setRedirectUrl(`/dashboard/${moduleBase}/${id}/common-costs`);
          setRedirect(true); */
        /*     setRedirectUrl(`/dashboard/${moduleBase}/${id}/common-costs`);
        setRedirect(true); */
        Toast.fire({
          type: "success",
          title: `Gasto actualizado exitosamente.`,
        });
      }
    } catch (error) {
      handleErrorMessage(error);
    }
  };

  const [common, setCommon] = useState();
  useEffect(() => {
    let isMounted = true;
    const fetchApiCommon = async () => {
      try {
        const response = await findOne(commonId);
        if (isMounted) {
          setCommon(response.data);
          console.log(response.data);
        }
      } catch (error) {
        if (isMounted) {
          setCommon();
        }
      }
    };

    fetchApiCommon();

    return () => {
      isMounted = false;
    };
  }, [commonId]);

  return (
    <>
      <PageHeader
        title={state?.type_name || "Gasto Común"}
        titleTag="h2"
        description="Asigna un gasto comun a un proveedor."
        className="mb-3"
        col={{ lg: 9 }}
      >
        <SupportLink />
      </PageHeader>
      <PreloadState loading={isLoading}>
        <CreateCommonCostsEditForm
          condominium={selectedCondominium}
          handleSubmitData={handleEdit}
          mutate={mutate}
          handler={{ nextPage, previousPage, perPage, goToPage, meta }}
          common={common}
          providers={data}
          properties={data}
        />
      </PreloadState>
    </>
  );
};

export default withRedirect(CreateCommonCostsEdit);
